import { FC, ReactNode } from "react";

import { ComponentFormGroup, ContainerAttributes, IDynamicForm, isDFGroupComponent } from "config";

import { findIndex, remove } from "lodash-es";

import { DynamicFormItemComponent } from "../DynamicFormItems";
import { AddressGroupComponent } from "./AddressGroupComponent";
import { ContainerGroupComponent } from "./ContainerGroupComponent/ContainerGroupComponent";
import { PhoneGroupComponent } from "./PhoneGroupComponent/PhoneGroupComponent";

export type DynamicFormGroupComponentProps = {
  group: ComponentFormGroup;
  items: IDynamicForm["items"];
  children?: ReactNode;
  attributesSet?: ContainerAttributes | null;
};

const formGroupsComponentMap: Record<
  ComponentFormGroup["detail"]["type"],
  FC<DynamicFormGroupComponentProps>
> = {
  address: AddressGroupComponent as FC<DynamicFormGroupComponentProps>,
  phone: PhoneGroupComponent,
  container: ContainerGroupComponent as FC<DynamicFormGroupComponentProps>,
};

// Renders DynamicFormItemComponent(s) in ComponentGroupDetail.type
export const MapGroupComponentToItems: FC<GroupComponentProps> = ({ children, groups, items }) => {
  const groupComponents = (groups || []).filter(isDFGroupComponent);

  const mappedGroupComponentToItems = groupComponents.reduce((mappedFormItems, group) => {
    const FormGroupComponent = formGroupsComponentMap[group.detail.type];
    const indexOfItemToReplace = findIndex(mappedFormItems, [
      "props.item.key",
      group.detail.replacementKey,
    ]);

    const removedDynamicFormItems = remove(mappedFormItems, item => {
      return group.detail.itemKeys.includes(item.props.item?.key);
    });

    mappedFormItems.splice(
      indexOfItemToReplace,
      0,
      <FormGroupComponent
        items={items}
        group={group}
        key={group.detail.replacementKey}
        attributesSet={group.detail.attributesSet}>
        {removedDynamicFormItems}
      </FormGroupComponent>
    );

    return mappedFormItems;
  }, children);

  return <>{mappedGroupComponentToItems}</>;
};

interface GroupComponentProps {
  children: ReturnType<typeof DynamicFormItemComponent>[];
  groups: IDynamicForm["groups"];
  items: IDynamicForm["items"];
}

export { formGroupsComponentMap };
